export const zIndex = {
  myLightbox: 3147483647,
  bankDescription: 3147483660,
  toast: 9999999,
};

export default {};
